export const Configuration = {
  microservice: {
    baseURL: process.env.REACT_APP_BASE_URl_MS,
  },
};
